export const initialQuestions = [
  {
    fieldName: 'skipSheathingPresent',
    question: 'Is there skip sheathing present?',
    warning: 'Timberline Solar must be installed on solid decking',
    answer: null,
  },
  {
    fieldName: 'radiantBarrierInstalled',
    question: 'Is there a radiant barrier installed on the underside of the roof deck?',
    warning: 'This material is incompatible with Timberline Solar',
    answer: null,
  },
  {
    fieldName: 'sprayFoamInstallationPresent',
    question: 'Is there spray foam insulation present on the underside of the roof deck?',
    warning: 'This material is incompatible with Timberline Solar',
    answer: null,
  },
];
